import { TranslationService } from '@/app/services/translation.service';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { environment } from '@environments/environment';
import { Missing } from '../../models';

@Component({
  selector: 'app-lineup-player',
  standalone: true,
  imports: [],
  templateUrl: './lineup-player.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LineupPlayerComponent {
  lineUpPlayer = input.required<Missing>();
  isRTL = input<boolean>(false);

  translationService = inject(TranslationService);

  getPlayerName() {
    if (!this.lineUpPlayer().Name && !this.lineUpPlayer().NameTranslation) {
      return '-';
    }

    return (
      this.translationService.getTraduccionName(
        this.lineUpPlayer().NameTranslation,
        this.lineUpPlayer().Name
      ) ?? '-'
    );
  }

  getImageUrl() {
    if (!this.lineUpPlayer().Photo || this.lineUpPlayer().Photo.length === 0) {
      return environment.urlIMG + 'default.png';
    }
    return this.lineUpPlayer().Photo;
  }
}
